export const queryKeys = {
  ACTIVITY_LOGS: 'ACTIVITY_LOGS',
  ACTIVITY_LOGS_PIPES: 'ACTIVITY_LOGS_PIPES',
  ACTIVITY_LOGS_FILTER: 'ACTIVITY_LOGS_FILTER',
  ACTIVITY_LOGS_FILTER_CLIENT: 'ACTIVITY_LOGS_FILTER_CLIENT'
};
